import React from "react";
import { reportClientError } from "./services/clientLogger";

/**
 * ครอบทั้งแอป — ถ้า React render พัง(throw ใน render/lifecycle) จะไม่จอขาว
 * แต่แสดงหน้า fallback + ยิง stack + componentStack ไป client-log ให้ debug ได้
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportClientError({
      level: "error",
      message: error && error.message ? error.message : "React render error",
      url: typeof window !== "undefined" ? window.location.href : undefined,
      stack:
        (error && error.stack ? String(error.stack) : "") +
        "\n--- componentStack ---" +
        (info && info.componentStack ? info.componentStack : ""),
      meta: { kind: "react-error-boundary" },
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: 40,
            textAlign: "center",
            fontFamily: '"TH Sarabun New", Sarabun, sans-serif',
          }}
        >
          <h2 style={{ fontSize: 24 }}>เกิดข้อผิดพลาดในการแสดงผล</h2>
          <p style={{ fontSize: 18, color: "#555" }}>
            ระบบบันทึกปัญหานี้ไว้แล้ว ทีมงานจะตรวจสอบให้ครับ
          </p>
          <button
            onClick={this.handleReload}
            style={{
              fontSize: 18,
              padding: "8px 24px",
              marginTop: 16,
              cursor: "pointer",
              borderRadius: 6,
              border: "1px solid #1976d2",
              background: "#1976d2",
              color: "#fff",
            }}
          >
            โหลดหน้าใหม่
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
